import React from 'react';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons/faLocationDot';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import IconMessageColumn from '../../../components/columns/icon-message-column';
import Global from '../../../store/global-selectors';

import { messages } from '../messages';

const deliveryNotificationToState = {
  NotSent: 'empty',
  Sent: 'normal',
  Failed: 'error',
};

const DeliveryNotificationColumn = ({ fulfillmentId }) => {
  const { deliveryEmailNotification } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { status, errorMessage } = deliveryEmailNotification ?? {};

  const deliveryNotification = status ?? 'NotSent';
  const tooltipMessage = errorMessage ?? <FormattedMessage {...messages.deliveryNotification} />;
  return (
    <IconMessageColumn
      icon={faLocationDot}
      message={<FormattedMessage {...messages.sent} />}
      state={deliveryNotificationToState[deliveryNotification]}
      tooltipMessage={tooltipMessage}
    />
  );
};

DeliveryNotificationColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const DeliveryNotification = {
  getMessageDescriptor: () => messages.deliveryNotification,
  id: 'delivery-notification',

  render: (data) => {
    return <DeliveryNotificationColumn fulfillmentId={data.id} />;
  },
};
